import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { MediaData } from '~admin/model/media-data';
import { mapMediaData } from '~admin/model/media-data.mapper';
import { MediaResponse } from '~client/model/media-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type MediaTranslationUploadTask = OneArgTask<FormData, MediaData>;

/* Allows to upload media in other languages for given mediaId */
export const performMediaTranslationUpload = (formData: FormData): Observable<MediaResponse> =>
  apiClient.mediaAdminController.uploadTranslation$(formData);

export const mediaTranslationUploadFactory = (): MediaTranslationUploadTask =>
  rxTask<FormData, MediaData>((formData: FormData) =>
    performMediaTranslationUpload(formData).pipe(map(mapMediaData)),
  );



// WEBPACK FOOTER //
// ./interactor/media/perform-upload-media-translation.ts